import React from "react";
import {
  MenuItem,
  Select,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { billingStates } from "ui/pages/transactions/PayoutDetails/constants";

export const StateSelect = ({ value, onChange, onBlur, meta, placeholder }) => {
  const hasError = meta?.touched && !!meta?.error;
  return (
    <FormControl fullWidth variant="outlined" error={hasError} size="small">
      <Select
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        displayEmpty
        style={{ background: "#fff" }}
      >
        <MenuItem value="" disabled>
          <span style={{ color: "#aaa" }}>{placeholder}</span>
        </MenuItem>
        {billingStates.map(({ name: stateName }) => (
          <MenuItem key={stateName} value={stateName}>
            {stateName}
          </MenuItem>
        ))}
      </Select>
      {hasError && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};
